<script lang="ts">
  import ModuleEtablissement from '@/generated/modules/ModuleEtablissement.vue';
  import { defineComponent } from "vue";
  import {
    storeAccidentTravail,
    storeAdresse,
    storeApprenti,
    storeContact,
    storeDocument,
    storeEtablissement, storeNotif, storePaymentMeans, storeQualite, storeRib, storeSalarie, storeTransaction
  } from "@/generated/stores";
  import { ListFilter } from "@/extend/classes/ListData.ts";

  export default defineComponent({
    components: {},
    extends: ModuleEtablissement,

    computed: {
      storesLoaded (): boolean {
        return storeEtablissement.etablissementLoaded &&
          storePaymentMeans.paymentMeansLoaded;
      }
    },

    methods: {
      loadStores (): void {
        const allData = new ListFilter();
        allData.pageLimit = -1;
        // Load and register events on used server classes
        storeAccidentTravail.registerAccidentTravail();
        storeAdresse.registerAdresse();
        storeApprenti.registerApprenti();
        storeContact.registerContact();
        storeDocument.registerDocument();
        storeEtablissement.registerEtablissement(allData);
        storeNotif.registerNotif();
        storePaymentMeans.registerPaymentMeans(allData);
        storeQualite.registerQualite();
        storeRib.registerRib();
        storeSalarie.registerSalarie();
        storeTransaction.registerTransaction();
      }
    }
  })

</script>
